import Vue from 'vue'
import Router from 'vue-router'
/* Layout */
import Layout from '../views/layout/Layout'

Vue.use(Router)

/**
 * hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
 *                                if not set alwaysShow, only more than one route under the children
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noredirect           if `redirect:noredirect` will no redirct in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    title: 'title'               the name show in submenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar,
  }
 **/
export const constantRouterMap = [
  {path: '/login', component: () => import('@/views/login/index'), hidden: true},
  {path: '/404', component: () => import('@/views/404'), hidden: true},
  {
    path: '',
    component: Layout,
    redirect: '/home',
    meta: {title: '首页', icon: 'home'},
    children: [{
      path: 'home',
      name: 'home',
      component: () => import('@/views/home/index'),
      meta: {title: '仪表盘', icon: 'dashboard'}
    },
    ]
  }
]

export const asyncRouterMap = [
  {
    path: '/ums',
    component: Layout,
    redirect: '/ums/admin',
    name: 'ums',
    meta: {title: '权限', icon: 'ums'},
    children: [
      {
        path: 'admin',
        name: 'admin',
        component: () => import('@/views/ums/admin/index'),
        meta: {title: '用户列表', icon: 'ums-admin'}
      },
      {
        path: 'role',
        name: 'role',
        component: () => import('@/views/ums/role/index'),
        meta: {title: '角色列表', icon: 'ums-role'}
      },
      {
        path: 'allocMenu',
        name: 'allocMenu',
        component: () => import('@/views/ums/role/allocMenu'),
        meta: {title: '分配菜单'},
        hidden: true
      },
      {
        path: 'allocResource',
        name: 'allocResource',
        component: () => import('@/views/ums/role/allocResource'),
        meta: {title: '分配资源'},
        hidden: true
      },
      {
        path: 'menu',
        name: 'menu',
        component: () => import('@/views/ums/menu/index'),
        meta: {title: '菜单列表', icon: 'ums-menu'}
      },
      {
        path: 'addMenu',
        name: 'addMenu',
        component: () => import('@/views/ums/menu/add'),
        meta: {title: '添加菜单'},
        hidden: true
      },
      {
        path: 'updateMenu',
        name: 'updateMenu',
        component: () => import('@/views/ums/menu/update'),
        meta: {title: '修改菜单'},
        hidden: true
      },
      {
        path: 'resource',
        name: 'resource',
        component: () => import('@/views/ums/resource/index'),
        meta: {title: '资源列表', icon: 'ums-resource'}
      },
      {
        path: 'resourceCategory',
        name: 'resourceCategory',
        component: () => import('@/views/ums/resource/categoryList'),
        meta: {title: '资源分类'},
        hidden: true
      }
    ]
  },
  {
    path: '/user',
    component: Layout,
    redirect: '/user',
    name: 'user',
    meta: {title: '用户管理', icon: 'user'},
    children: [
      {
        path: 'userList',
        name: 'userList',
        component: () => import('@/views/unc/user/userList'),
        meta: {title: '用户列表', icon: 'sms-flash'}
      },
      {
        path: 'upgradeList',
        name: 'upgradeList',
        component: () => import('@/views/unc/user/upgradeList'),
        meta: {title: '升级记录', icon: 'sms-flash'}
      },
      {
        path: 'teamList',
        name: 'teamList',
        component: () => import('@/views/unc/user/teamList'),
        meta: {title: '团队列表', icon: 'sms-flash'}
      },
      {
        path: 'notice',
        name: 'notice',
        component: () => import('@/views/unc/user/notice'),
        meta: {title: '公告列表', icon: 'sms-flash'}
      }
    ]
  },
  {
    path: '/asset',
    component: Layout,
    redirect: '/asset',
    name: 'asset',
    meta: {title: '资产管理', icon: 'order'},
    children: [
      {
        path: 'assetList',
        name: 'assetList',
        component: () => import('@/views/unc/asset/assetList'),
        meta: {title: '资产明细', icon: 'sms-flash'}
      },
      {
        path: 'rechargeList',
        name: 'rechargeList',
        component: () => import('@/views/unc/asset/rechargeList'),
        meta: {title: '购买列表', icon: 'sms-flash'}
      },
      {
        path: 'outputList',
        name: 'outputList',
        component: () => import('@/views/unc/asset/outputList'),
        meta: {title: '产出列表', icon: 'sms-flash'}
      },
      {
        path: 'withdrawList',
        name: 'withdrawList',
        component: () => import('@/views/unc/asset/withdrawList'),
        meta: {title: '提现列表', icon: 'sms-flash'}
      },
      {
        path: 'recharge',
        name: 'recharge',
        component: () => import('@/views/unc/asset/recharge'),
        meta: {title: '充值列表', icon: 'sms-flash'}
      }
    ]
  },
  {
    path: '/pledge',
    component: Layout,
    redirect: '/pledge',
    name: 'pledge',
    meta: {title: '超级质押', icon: 'order'},
     children: [
      {
        path: 'nodeList',
        name: 'nodeList',
        component: () => import('@/views/pledge/nodeList'),
        meta: {title: '节点列表', icon: 'sms-flash'}
      },
      {
        path: 'orderList',
        name: 'orderList',
        component: () => import('@/views/pledge/orderList'),
        meta: {title: '订单列表', icon: 'sms-flash'}
      },
     ]
  },
  // {
  //   path: '/mining',
  //   component: Layout,
  //   redirect: '/mining',
  //   name: 'mining',
  //   meta: {title: '联合挖矿', icon: 'order'},
  //   children: [
  //     {
  //       path: 'swapList',
  //       name: 'swapList',
  //       component: () => import('@/views/unc/mining/swapList'),
  //       meta: {title: '兑换记录', icon: 'sms-flash'}
  //     },
  //     {
  //       path: 'outputList',
  //       name: 'outputList',
  //       component: () => import('@/views/unc/mining/outputList'),
  //       meta: {title: '产出记录', icon: 'sms-flash'}
  //     }
  //   ]
  // },
  // {
  //   path: '/rechargeMining',
  //   component: Layout,
  //   redirect: '/rechargeMining',
  //   name: 'rechargeMining',
  //   meta: {title: '联合算力挖矿', icon: 'order'},
  //   children: [
  //     {
  //       path: 'orderList',
  //       name: 'orderList',
  //       component: () => import('@/views/unc/rechargeMining/orderList'),
  //       meta: {title: '订单记录', icon: 'sms-flash'}
  //     },
  //     {
  //       path: 'recordList',
  //       name: 'recordList',
  //       component: () => import('@/views/unc/rechargeMining/recordList'),
  //       meta: {title: '燃烧记录', icon: 'sms-flash'}
  //     },
  //     {
  //       path: 'outputList',
  //       name: 'outputList',
  //       component: () => import('@/views/unc/rechargeMining/outputList'),
  //       meta: {title: '产出记录', icon: 'sms-flash'}
  //     }
  //   ]
  // },
  {
    path: '/statistics',
    component: Layout,
    redirect: '/statistics',
    name: 'statistics',
    meta: {title: '统计管理', icon: 'order'},
    children: [
      {
        path: 'statistics',
        name: 'statistics',
        component: () => import('@/views/unc/statistics/index'),
        meta: {title: '统计数据', icon: 'sms-flash'}
      },
    ]
  },
  {
    path: '/settings',
    component: Layout,
    redirect: '/settings',
    name: 'settings',
    meta: {title: '配置管理', icon: 'order'},
    children: [
      {
        path: 'systemConfig',
        name: 'systemConfig',
        component: () => import('@/views/unc/settings/systemConfig'),
        meta: {title: '系统配置', icon: 'sms-flash'}
      },
      {
        path: 'levelConfig',
        name: 'levelConfig',
        component: () => import('@/views/unc/settings/levelConfig'),
        meta: {title: '级别配置', icon: 'sms-flash'}
      },
      {
        path: 'productConfig',
        name: 'productConfig',
        component: () => import('@/views/unc/settings/productConfig'),
        meta: {title: '产品配置', icon: 'sms-flash'}
      },
      {
        path: 'rewardWhitelist',
        name: 'rewardWhitelist',
        component: () => import('@/views/unc/settings/rewardWhitelist'),
        meta: {title: '白名单配置', icon: 'sms-flash'}
      }
    ]
  },
  {path: '*', redirect: '/404', hidden: true}
]

export default new Router({
  // mode: 'history', //后端支持可开
  scrollBehavior: () => ({y: 0}),
  routes: constantRouterMap
})




// WEBPACK FOOTER //
// ./src/router/index.js